<template>
  <app-main-layout>
    <!--  -->
    <!-- Main Left Menu  -->
    <template v-slot:left>
      <app-left-nav />
    </template>
    <!--  -->
    <!-- Main Top Menu -->
    <template v-slot:top>
      <app-top-nav padded>
        <template v-slot:left>
          <el-page-header nav-title> Bids </el-page-header>
        </template>
        <template v-slot:center>
          <span>
            <!-- Search -->
          </span>
        </template>
        <template v-slot:right>
          <!-- Other buttons -->
        </template>
      </app-top-nav>
    </template>
    <!--  -->
    <!-- Main Content -->
    <template v-slot:main>
      <!--  -->
      <!-- Charts -->
      <!--  -->
      <!-- Loaded biddings -->
      <div app-main-content>
        <BiddingsList :biddings="biddings"></BiddingsList>
      </div>
    </template>
    <!--  -->
    <!--  -->
    <!--  -->
  </app-main-layout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import BiddingsList from "./components/biddings-list.component.vue";

@Options({
  components: { BiddingsList },
})
export default class extends Vue {
  /**
   * @returns biddings
   */
  get biddings() {
    return this.$store.state.biddings.biddings;
  }

  /**
   * @returns biddings
   */
  get loading() {
    return this.$store.state.biddings.loading;
  }

  mounted() {
    this.$store.dispatch("biddings/fetch");
  }
}
</script>

<style lang="scss"></style>
